module.exports = __webpack_public_path__ + "img/thumbnail_AmericanBullfrog_u_albino.f84c3ff9.png";